import { useState } from 'react';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin, 
  Youtube,
  Mail,
   Share2,
  X
} from 'lucide-react';
import { SiTiktok,SiWhatsapp,SiTelegram } from 'react-icons/si';



export default function SocialMediaIconsRight() {
  const [showMobileIcons, setShowMobileIcons] = useState(false);

  const socialLinks = {
    facebook: 'https://www.facebook.com/profile.php?id=61580404940006',
    twitter: 'https://wa.me/251938635555',
    instagram: 'https://www.instagram.com/ysskytourandtravelagencyplc?igsh=MTNpcmllYzZyN3ZucA==',
      telegram: 'https://t.me/ysskytourandtravel',
    youtube: 'https://www.tiktok.com/@ysskytravel?_r=1&_t=ZM-91VE7te8dkh',
  
  };

  const socialStyles = {
    facebook: "bg-[#1877F2] text-white",
    twitter: "bg-[#25D366] text-white",
    instagram: "bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white",
    linkedin: "bg-[#0A66C2] text-white",
    youtube: "bg-black text-white",
    telegram: "bg-[#0088cc] text-white",
    email: "bg-[#34A853] text-white"
  };

  const IconSize = 20;

  return (
    <>
      {/* Desktop Version - Right Side */}
      <div className="fixed right-4 top-1/2 transform -translate-y-1/2 z-50 hidden lg:flex flex-col items-center space-y-4">
        <div className="w-0.5 h-20 bg-gray-400 dark:bg-gray-600"></div>

        {Object.entries(socialLinks).map(([key, url]) => (
          <a
            key={key}
            href={url}
            target={key !== "email" ? "_blank" : undefined}
            rel="noopener noreferrer"
            className={`flex items-center justify-center ${socialStyles[key]} w-10 h-10 rounded-full shadow-md hover:scale-110 transition-transform duration-300`}
          >
            {key === "facebook" && <Facebook size={IconSize} />}
            {key === "twitter" && <SiWhatsapp size={IconSize} />}
            {key === "instagram" && <Instagram size={IconSize} />}
           {key === "telegram" && <SiTelegram size={IconSize} />}
            {key === "youtube" && <SiTiktok size={IconSize} />}
            
          </a>
        ))}

        <div className="w-0.5 h-20 bg-gray-400 dark:bg-gray-600"></div>
      </div>

      {/* Mobile Version - Bottom Bar (toggleable) */}
      {showMobileIcons && (
        <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-gray-700">
          <div className="flex justify-around items-center py-3 px-4">
            {Object.entries(socialLinks).map(([key, url]) => (
              <a
                key={key}
                href={url}
                target={key !== "email" ? "_blank" : undefined}
                rel="noopener noreferrer"
                className={`flex items-center justify-center ${socialStyles[key]} w-10 h-10 rounded-full shadow-md hover:scale-110 transition-transform duration-300`}
              >
                {key === "facebook" && <Facebook size={IconSize} />}
                {key === "twitter" && <SiWhatsapp size={IconSize} />}
                {key === "instagram" && <Instagram size={IconSize} />}
               {key === "telegram" && <SiTelegram size={IconSize} />}
                {key === "youtube" && <SiTiktok size={IconSize} />}
                {key === "email" && <Mail size={IconSize} />}
              </a>
            ))}
          </div>
        </div>
      )}

      {/* Mobile Toggle Button */}
      <button
        onClick={() => setShowMobileIcons(prev => !prev)}
        className="fixed bottom-20 right-4 z-50 bg-gray-800 dark:bg-gray-200 text-white dark:text-black w-10 h-10 rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform duration-300 lg:hidden"
      >
        {showMobileIcons ?  <X size={24} /> : <Share2 size={24} />}
      </button>
    </>
  );
}
